import React from 'react';
import FacebookLogin from 'react-facebook-login';

type SuccessCallbackType = (response: any) => void;

interface FacebookSignUpProps {
  onResponse: SuccessCallbackType;
}

// @ts-ignore
export const FacebookSignUp: React.FC<FacebookSignUpProps> = ({ onResponse }) => {
  const appId = '9877725315634892';

  // const responseFacebook = (response: any) => {
  //     console.log(response);
  // };

  return (
    <FacebookLogin
      appId={appId} // Replace with your Facebook App ID
      autoLoad={false}
      fields="name,email,picture"
      callback={onResponse}
    />
  );
};
export default FacebookSignUp;
